import i18next from 'i18next';
import { StellantisQuoteInfoTooltip, StellantisUtils } from '../../components/Stellantis';
import ToolTip from 'src/components/Tooltip/Tooltip';
import { formatDate } from 'src/utils';
import _ from 'lodash';
import { RoleEnum } from 'src/api';
export const columnsData = [
  {
    accessor: 'countdown_scadenza',
    id: 'countdown_scadenza',
    Header: i18next.t('countdown_scadenza'),
    disableSortBy: true,
    Cell: ({ row }) => {
      const countdownStatus = row.original.countdownStatus;
      const timeLeft = row.original.timeLeft;
      const colorByStatus = (countdownStatus === 'warning' ? '#CC6600' : countdownStatus === 'expired' ? 'red' : undefined)
      const formatTime = (time: number) => time.toString();
      const inTime = timeLeft.hours > 0 || timeLeft.minutes > 0;
      const textColor = ['warning', 'expired'].includes(countdownStatus) ? 'white' : 'black';

      return StellantisUtils.isQuoted(row.original)
        ? i18next.t('quote_status_quoted')
        : (
          <div className='d-flex justify-content-center align-items-center' style={{ color: textColor, backgroundColor: colorByStatus }}>
            <div className="fw-bold px-3 py-1 text-center">
              {(timeLeft.hours > 0 || timeLeft.minutes > 0)
                ? (`${formatTime(timeLeft.hours)}h ${formatTime(timeLeft.minutes)}m`)
                : (`-${formatTime(Math.abs(timeLeft.passed?.hours || 0))}h ${formatTime(Math.abs(timeLeft.passed?.minutes || 0))}m`)
              }
            </div>
          </div>
        )
    },
  },
  {
    id: 'requestDate',
    disableSortBy: true,
    Header: i18next.t('requestDate'),
    accessor: (values) => {
      return formatDate(values.requestDate + "Z", 'it-IT', true);
    },
    Cell: ({ row }) => {
      const rawDate = row?.original?.requestDate;
      if (!rawDate) return null;
      const formatted = formatDate(rawDate + "Z", 'it-IT', true);
      return formatted === 'Invalid Date' ? rawDate : formatted;
    },
  },
  {
    accessor: 'dealer',
    id: 'dealer',
    disableSortBy: true,
    Header: i18next.t('dealer_or_segnalatore'),
    Cell: ({ row }) => {
      let value = row?.original?.dealer;

      if (row?.original?.requestedByRole === RoleEnum.SEGNALATORE) {
        value = (
          <>
            <div>{value}</div>
            <small>{'(Segnalatore)'}</small>
          </>
        )
      }

      return value;
    }
  },
  {
    id: 'requestedBy',
    Header: i18next.t('user'),
    disableSortBy: true,
    minWidth: 290,
    accessor: (values) => {
      return values.requestedByFullname || values.requestedBy;
    },
    Cell: ({ row }) => {
      const elId = `info-requestedBy-${row.id}`;
      const maxChars = 20;
      const value = (row?.original?.requestedByFullname || row?.original?.requestedBy);
      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    accessor: 'quote.marca',
    id: 'marca',
    Header: i18next.t('marca'),
    disableSortBy: true,
  },
  {
    accessor: 'quote.modello',
    id: 'modello',
    Header: i18next.t('modello'),
    disableSortBy: true,
  },
  {
    accessor: 'quote.allestimento',
    id: 'allestimento',
    Header: i18next.t('allestimento'),
    width: 140,
    className: 'text-wrap',
    disableSortBy: true,
    Cell: ({ row }) => {
      const elId = `info-allestimento-${row.id}`;
      const maxChars = 50;
      const value = row?.original?.quote?.allestimento || '';
      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId} className='text-wrap' style={{ minWidth: 240 }}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    Header: i18next.t('other'),
    id: 'expander',
    disableSortBy: true,
    Cell: ({ row }) => {
      return <StellantisQuoteInfoTooltip quoteRequest={row.original} type='request' />
    },
  },
  {
    id: 'actions',
    Header: i18next.t('gestione'),
    disableSortBy: true,
    accessor: (values) => {
      return values.assignedToFullname || values.assignedTo || 'actions';
    },
  },
];
